import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppShell from "./components/AppShell";
import HomePage from "./pages/HomePage";
import {
  PrviDneviPage,
  UcivaSeHranjenjaPage,
  TvojeTeloPage,
  PovezanostPage,
  OValDotikaPage,
} from "./pages/SubPages";
import MasazaDojenckaPage from "./pages/programi/MasazaDojenckaPage";
import AurikulotherapyPage from "./pages/programi/AurikulotherapyPage";
import TrebuscekPage from "./pages/programi/TrebuscekPage";
import BlogListPage from "./pages/BlogListPage";
import BlogArticlePage from "./pages/BlogArticlePage";
import AdminLoginPage from "./pages/AdminLoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPostEditor from "./pages/AdminPostEditor";
import AdminCategories from "./pages/AdminCategories";
import AdminChangePassword from "./pages/AdminChangePassword";
import AboutPage from "./pages/AboutPage";
import PrivacyPage from "./pages/PrivacyPage";
import TermsPage from "./pages/TermsPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Main public routes with new AppShell (header/footer/popup/cookie) */}
          <Route element={<AppShell />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/prvi-dnevi-po-porodu" element={<PrviDneviPage />} />
            <Route path="/uciva-se-hranjenja" element={<UcivaSeHranjenjaPage />} />
            <Route path="/tvoje-telo" element={<TvojeTeloPage />} />
            <Route path="/povezanost" element={<PovezanostPage />} />
            <Route path="/o-val-dotika" element={<OValDotikaPage />} />
            <Route path="/programi/masaza-dojencka" element={<MasazaDojenckaPage />} />
            <Route path="/programi/trebuscek" element={<TrebuscekPage />} />
            <Route path="/programi/aurikuloterapija" element={<AurikulotherapyPage />} />
          </Route>

          {/* Legacy standalone pages (own header/footer) */}
          <Route path="/blog" element={<BlogListPage />} />
          <Route path="/blog/:slug" element={<BlogArticlePage />} />
          <Route path="/o-drustvu" element={<AboutPage />} />
          <Route path="/politika-zasebnosti" element={<PrivacyPage />} />
          <Route path="/pogoji-sodelovanja" element={<TermsPage />} />

          {/* Admin */}
          <Route path="/admin" element={<AdminLoginPage />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/posts/new" element={<AdminPostEditor />} />
          <Route path="/admin/posts/:id/edit" element={<AdminPostEditor />} />
          <Route path="/admin/categories" element={<AdminCategories />} />
          <Route path="/admin/change-password" element={<AdminChangePassword />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
